<div class="sp-p-16">
  <div class="sp-mb-48">
    <h4 class="sp-mb-12">Various Alert Types:</h4>

    <div ui-row [uiGutter]="[24, 24]">
      <div ui-col uiXs="24">
        <ui-alert uiType="success" uiMessage="Success Tips" uiShowIcon></ui-alert>
      </div>
      <div ui-col uiXs="24">
        <ui-alert uiType="info" uiMessage="Informational Notes" uiShowIcon></ui-alert>
      </div>
      <div ui-col uiXs="24">
        <ui-alert uiType="warning" uiMessage="Warning" uiShowIcon></ui-alert>
      </div>
      <div ui-col uiXs="24">
        <ui-alert uiType="error" uiMessage="Error" uiShowIcon></ui-alert>
      </div>
      <div ui-col uiXs="24">
        <ui-alert uiType="success" uiMessage="Success Tips" uiDescription="Detailed description and advices about successful copywriting." uiShowIcon></ui-alert>
      </div>
      <div ui-col uiXs="24">
        <ui-alert uiType="info" uiMessage="Informational Notes" uiDescription="Additional description and informations about copywriting." uiShowIcon></ui-alert>
      </div>
      <div ui-col uiXs="24">
        <ui-alert uiType="warning" uiMessage="Warning" uiDescription="This is a warning notice about copywriting." uiShowIcon></ui-alert>
      </div>
      <div ui-col uiXs="24">
        <ui-alert uiType="error" uiMessage="Error" uiDescription="This is an error message about copywriting." uiShowIcon></ui-alert>
      </div>
    </div>
  </div>
</div>
